import { useState } from 'react';

export function useToast() {
  const [toast, setToast] = useState<{
    message: string;
    type: 'error' | 'success';
  } | null>(null);
  return { toast, setToast };
}
